export default __webpack_public_path__ + "assets/ping_image.png";